module.exports = __webpack_public_path__ + "img/IMG_3539_L_Foamcore.671119e3.jpg";